import { QueryKeys } from "../../../../../../hooks/reactQuery/queryKeys";
import { useQueryState } from "../../../../../../hooks/reactQuery/useQueryState";
import { useStoreActions } from "../../../../../../store/store-context";
export const useLegalTerms = () => {
  const {
    api
  } = useStoreActions();
  const {
    data: legalTerms,
    isLoading,
    isFetching
  } = useQueryState({
    queryKey: [QueryKeys.LegalTerms],
    queryFn: () => api.business.getLegalTerms(),
    keepDataFresh: true
  });
  return {
    legalTerms: legalTerms !== null && legalTerms !== void 0 ? legalTerms : [],
    isLoading,
    isFetching
  };
};